// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__frank_8d7299', '__frank_Fallback_8d7299'"},"className":"__className_8d7299","variable":"__variable_8d7299"};